import type { estypes } from '@elastic/elasticsearch'

import { textSubtypes } from './utils'

export const auditQuestionsMapping = {
  organizationId: {
    type: 'keyword',
    index: false,
  },
  noteId: {
    type: 'keyword',
    index: false,
  },
  indexedAt: {
    type: 'date',
  },
  question: {
    type: 'text',
    ...textSubtypes,
  },
  persona: {
    type: 'keyword',
  },
  type: {
    type: 'keyword',
  },
  categories: {
    type: 'keyword',
  },
  categoriesWithScore: {
    type: 'rank_features',
  },
  hasAnswer: {
    type: 'boolean',
    index: false,
  },
} satisfies Record<string, estypes.MappingProperty>
